<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <div class="block">
        <span style="margin-right:20px;">过滤关键字</span>

        <a-input
          placeholder="请输入内容"
          v-model="queryParam.keyWord"
          style="width:200px;"
          allow-clear
        />
        <span class="demonstration" style="margin:0 20px;">时间筛选</span>
        <a-range-picker @change="changeTime" v-model="conditionDate">
        </a-range-picker>
        <a-button
          type="primary"
          @click="searchQuery"
          icon="search"
          style="margin-left:20px"
          >查询</a-button
        >
        <a-button
          type="primary"
          @click="searchResetWarn"
          icon="reload"
          style="margin-left: 8px"
          >重置</a-button
        >
      </div>

      <a-form
        layout="inline"
        @keyup.enter.native="searchQuery"
        style="margin-top:20px;"
      >
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button
                type="primary"
                @click="handleAdd"
                icon="plus"
                style="margin-left: 8px"
                >新增</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- table -->
    <div style="height:574px;overflow-y: scroll;">
      <a-table
        :columns="columns"
        bordered
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange"
        :rowKey="r => r.id"
      >
        <a slot="name" slot-scope="text">{{ text }}</a>
        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)" v-has="'user:edit'">编辑</a>-->
          <!-- <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" /> -->
          <a @click="goview(record)">查看</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <warning-modal ref="modalForm" @ok="modalFormOk"></warning-modal>
    <!-- <addwarning-modal ref="modalForm"></addwarning-modal> -->
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import warningModal from './warningModal';

export default {
  name: 'warningrecord',
  mixins: [JeecgListMixin],
  components: {
    warningModal
  },
  data() {
    return {
      conditionDate: null,
      columns: [
        {
          title: '过滤关键字',
          dataIndex: 'keyWord',
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createBy',
          align: 'center',
          customRender: function(text, record, index) {
            if (!text) {
              return '--';
            }
            let list = JSON.parse(sessionStorage.getItem('CREATEPOPLIST'));
            let textTemp = text.toLocaleLowerCase();
            let target = list.find(
              item => item.userName.toLocaleLowerCase() == textTemp
            );
            if (target) {
              return target.realName;
            } else {
              return text;
            }
          }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '警告次数',
          dataIndex: 'warningTimes',
          key: 'warningTimes',
          ellipsis: true,
          align: 'center',
          sorter: (a, b) => a.warningTimes - b.warningTimes,
          customRender: (text, record, index) => {
            return <span>{{ text }}</span>;
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center'
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_CHATDATA + '/wechatwork/warning/list',
        // addwarning: process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/warning/add',
        delete: process.env.VUE_APP_CMS_CHATDATA + '/wechatwork/warning/delete'
      }
    };
  },
  created() {},

  methods: {
    searchResetWarn() {
      this.conditionDate = null;
      this.searchReset();
    },
    changeTime(value, dateStrings) {
      this.queryParam.startTime = dateStrings[0];
      this.queryParam.endTime = dateStrings[1];
    },
    goview(record) {
      console.log(record);
      this.$router.push({
        // path: '/wechatwork/supervision/chatDataList',
        // query: {warningId: record.id,warningStr: record.keyWord}
        path: '/wechatwork/supervision/chatDataListRe',
        query: {
          content: record.keyWord,
          type: 1,
          sendId: record.id,
          pageForm: 'warning'
        }
      });
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
.block /deep/ .el-date-editor .el-range-input {
  width: 40% !important;
}
</style>
